export class ResolveTenantRequest {
  c: string;
}

export class ResetPasswordRequest {
  userId: number;
  resetCode: string;
  password: string;
  passwordRepeat: string;
  c: string;
}

export interface ResetPasswordResponseModelData {
  result: ResetPasswordResponseModel;
}

export class ResetPasswordResponseModel {
    canLogin: boolean;
    userName: string;
}


export class ForgotPasswordRequest {
  emailAddress: string;
  isFromEcamCentral: boolean = true;
}

export interface IPasswordEditDto {
  userId: number | undefined;
  password: string | undefined;
}

export interface IChangePasswordDto {
  currentPassword: string | undefined;
  newPassword: string | undefined;
}

export class PasswordEditDto implements IPasswordEditDto {
  userId!: number | undefined;
  password!: string | undefined;

  setPasswordEditDto(passwordEditDto: any) {
    this.userId = passwordEditDto.userId;
    this.password = passwordEditDto.password;
  }
}

export class ChangePasswordDto implements IChangePasswordDto {
  currentPassword!: string | undefined;
  newPassword!: string | undefined;

  setPasswordEditDto(changePasswordDto: any) {
    this.currentPassword = changePasswordDto.currentPassword;
    this.newPassword = changePasswordDto.newPassword;
  }
}
